import React, { useState } from 'react';
import { Radio } from 'antd';
import { toast } from 'react-toastify';
import useDataSaver, { enregistrerDataSaver } from '../../hooks/useDataSaver';
import './notificationPrefs.css';

// Paramètres > Économie de données (chantier 16/07).
// Frère de NotificationPrefs : mêmes classes (.nprefs*), même patron
// (enregistrement immédiat + toast), monté aux mêmes endroits — donc AUCUNE
// nouvelle page ni entrée de menu à créer, et aucun risque de menu invisible.
//
// Le réglage n'agit QUE sur le poids des photos téléchargées pour l'affichage.
// Il ne dégrade jamais le zoom plein écran ni les photos envoyées aux clientes
// sur WhatsApp : celles-ci utilisent toujours l'image d'origine.
const OPTIONS = [
  {
    value: 'auto',
    titre: 'Automatique',
    aide: 'Recommandé — photos allégées sur téléphone, pleine qualité sur ordinateur.',
  },
  {
    value: 'eco',
    titre: 'Économie de données',
    aide: 'Photos les plus légères partout. À choisir si votre forfait internet est limité.',
  },
  {
    value: 'qualite',
    titre: 'Qualité maximale',
    aide: 'Photos les plus nettes partout. Consomme davantage de données.',
  },
];

const DataSaverPrefs = () => {
  const mode = useDataSaver();
  const [envoi, setEnvoi] = useState(false);

  const choisir = async (v) => {
    if (envoi || v === mode) return;
    setEnvoi(true);
    try {
      await enregistrerDataSaver(v);
      toast.success('Préférence enregistrée.');
    } catch (e) {
      // Le cache local n'est mis à jour qu'APRÈS un PUT réussi : en cas d'échec
      // l'affichage montre encore l'ancienne valeur — rien à annuler.
      toast.error('Impossible d’enregistrer la préférence.');
    } finally { setEnvoi(false); }
  };

  return (
    <section className="nprefs">
      <h2 className="nprefs-titre">Économie de données</h2>
      <Radio.Group
        value={mode}
        disabled={envoi}
        onChange={(e) => choisir(e.target.value)}
        style={{ display: 'block' }}
      >
        {OPTIONS.map((o) => (
          <div className="nprefs-ligne" key={o.value}>
            <div>
              <b>{o.titre}</b>
              <small>{o.aide}</small>
            </div>
            <Radio value={o.value} />
          </div>
        ))}
      </Radio.Group>
      <p style={{ margin: '10px 2px 0', fontSize: 12, color: '#5d6b80' }}>
        Le zoom d’une photo et les photos envoyées aux clientes restent toujours en pleine résolution.
      </p>
    </section>
  );
};

export default DataSaverPrefs;
